import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconGreaterThanOrEqualToSymbolGroup: React.FC<SvgProps> = (
  props,
) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M84.1 93.7C67.7 87.1 59.7 68.5 66.3 52.1s25.2-24.4 41.6-17.8l320 128C440 167.1 448 178.9 448 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L329.8 192 84.1 93.7zM448 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconGreaterThanOrEqualToSymbolSvg: React.FC<SvgProps> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      {...(props.svg ?? {})}
    >
      <IconGreaterThanOrEqualToSymbolGroup {...props} />
    </svg>
  );
};
